import { removeAxiosAuth, setAxiosAuth } from "@/utils/api";
import { toNumber } from "@/utils/number";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

export const AUTH_COOKIE_EXPIRES_DAYS = toNumber(process.env.REACT_APP_AUTH_COOKIE_EXPIRES_DAYS) || 30;
const isDevMode = process.env.REACT_APP_APP_ENV === "DEV";

/**
 * Sets the access and refresh tokens in cookies and updates the Axios authentication configuration.
 *
 * @param {string} accessToken - The access token to set.
 * @param {string} refreshToken - The refresh token to set.
 */
export const setToken = (accessToken: string, refreshToken: string) => {
  const options: Cookies.CookieAttributes = { expires: AUTH_COOKIE_EXPIRES_DAYS };

  if (!isDevMode) {
    options.secure = true;
    options.sameSite = "strict";
  }
  Cookies.set("admin-token", accessToken, options);
  Cookies.set("admin-refresh-token", refreshToken, options);
  setAxiosAuth();
};

/**
 * Removes the access and refresh tokens from cookies and updates the Axios authentication configuration.
 */
export const removeToken = () => {
  Cookies.remove("admin-token");
  Cookies.remove("admin-refresh-token");
  removeAxiosAuth();
};

/**
 * Verifies if a given token is still valid based on its expiration time.
 *
 * @param {string} token - The token to verify.
 * @returns {boolean} - `true` if the token is still valid, `false` otherwise.
 */
export function verifyToken(token: string) {
  try {
    const decoded = jwtDecode<{ exp: number }>(token);
    return decoded.exp > new Date().getTime() / 1000;
  } catch (e) {
    return false;
  }
}
